// extracted by mini-css-extract-plugin
export default {"bg":"BackGround_bg__-xTdW"};